import React, { useState } from "react";
import { FaCloud, FaMobileAlt, FaCode, FaLock, FaChartLine, FaCogs } from "react-icons/fa";
import { motion } from "framer-motion";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import { title } from "framer-motion/client";
import "./custom.css";

import { useNavigate } from "react-router-dom";

const servicesData = [
    {
        category: "MS2",
        image: "./downloads/1.png",
        services: [
            {
                title: "Cloud Migration",
                description: "Seamless migration of your infrastructure and applications to the cloud.",
            }
           
        ],
    },
    {
        category: "Mobile & Web Development",
         image: "./downloads/2.png",
        services: [
            {
                title: "Mobile App Development",
                description: "Custom iOS and Android app development for your business.",
            },
            {
                title: "Web Application Development",
                description: "Modern, responsive web applications tailored to your needs.",
            },
        ],
    },
    {
        category: "Custom Software",
        image: "./downloads/3.png",
        services: [
            {
                title: "Enterprise Software",
                description: "Robust software solutions for enterprise-level requirements.",
            },
            {
                title: "API Development",
                description: "Secure and scalable API design and implementation.",
            },
        ],
    },
    {
        category: "Cybersecurity",
         image: "./downloads/4.png",
        services: [
            {
                title: "Security Audits",
                description: "Comprehensive security assessments for your IT assets.",
            },
            {
                title: "Data Protection",
                description: "Implement best practices for data privacy and protection.",
            },
        ],
    },
    {
        category: "Data & Analytics",
         image: "./downloads/5.png",
        services: [
            {
                title: "Business Intelligence",
                description: "Transform data into actionable insights.",
            },
            {
                title: "Data Engineering",
                description: "Build and maintain scalable data pipelines.",
            },
        ],
    },
    {
        category: "DevOps & Automation",
         image: "./downloads/6.png",
        services: [
            {
                title: "CI/CD Implementation",
                description: "Automate your software delivery pipeline.",
            },
            {
                title: "Infrastructure as Code",
                description: "Provision and manage infrastructure with code.",
            },
        ],
    },
];

const tabVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

const Download_page = () => {
    const [activeTab, setActiveTab] = useState(0);
const navigate = useNavigate();
    return (
        <>
           
            <Container className="py-5">
                <Row className="justify-content-center mb-4">
                    <Col md={8} className="text-center">
                        <h1 className="mb-3">Minix IT Hub Services</h1>
                        <p className="lead">
                            Empowering your business with innovative IT solutions. Explore our wide range of services designed to accelerate your digital transformation.
                        </p>
                    </Col>
                </Row>
                <Row>
                    
                        <div className="col-12 row" >
                            {servicesData.map((cat, idx) => (
                                <div className="col-4 img-hover-zoom" key={cat.category}>
                                   
                                        <img src={cat.image} title={cat.title} className="img-fluid m-2" alt={cat.title} height="300px" width="300px"></img>
                                        
                                   
                                </div>
                            ))}
                       
                 </div>
                  
                </Row>

                 <Row className="justify-content-center mb-4">
                    <Col md={8} className="text-center">
                    <h3>Let’s get started</h3>
                        <h1 className="mb-3">Are you ready for a better, more productive business?</h1>
                        <p className="lead h4">
                           “Innovative Minix Products, crafted with expertise by MINIX IT HUB PRIVATE LIMITED.
Reach out to us for inquiries, partnerships, or support.”
                        </p>
                        <Button onClick={()=>navigate("/contact") }  variant="primary" size="lg">Contact Us</Button>
                    </Col>
                </Row>
                
            </Container>
         
        </>
    );
};

export default Download_page;